import { render, staticRenderFns } from "./WidgetServiciosEn.vue?vue&type=template&id=55d301e0&"
import script from "./WidgetServiciosEn.vue?vue&type=script&lang=js&"
export * from "./WidgetServiciosEn.vue?vue&type=script&lang=js&"
import style0 from "./WidgetServiciosEn.vue?vue&type=style&index=0&id=55d301e0&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports